/* eslint-disable camelcase */
import parse from 'html-react-parser';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ActionButton from '../../../elements/ActionButton';
import Loader from '../../../elements/Loader';
import axios from '../../../services/MyAxios';
import { CasinoDepositBonus } from '../../Models/CasinoDepositBonus';
import BonusSummary from '../../elements/Bonuses/BonusSummary';
import { API_CASINO_DEPOSIT_BONUSES } from '../Helpers/CrmApiUrls';

import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import { CASINO_DEPOSIT_BONUSES } from '../Helpers/CrmUrls';

function DepositBonusShow() {
    const { id } = useParams<{ id: string }>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [depositBonus, setDepositBonus] = useState<CasinoDepositBonus>({
        id: 0,
        name: '',
        image_path: '',
        description: '',
        currency_code: '',
        min_deposit: 0,
        max_deposit: 0,
        casino_deposit_bonus_page_id: 0,
        bonus_percentage: 0,
        wagering_requirement: 0,
        count_of_days_to_fill_requirements_by_user: 1,
        available_from: '',
        available_to: '',
    });

    useEffect(() => {
        axios.get<CasinoDepositBonus>(`${API_CASINO_DEPOSIT_BONUSES}/${id}`).then((response) => {
            setDepositBonus(response.data);
        });
        setIsLoading(false);
    }, []);

    const getContent = () => {
        return (
            <div className="card">
                <div className="card-header">Deposit bonus details</div>
                <div className="card-body table-responsive">
                    <table className="table table-show">
                        <thead />
                        <tbody>
                            <tr key="id">
                                <th>ID</th>
                                <td>{depositBonus.id}</td>
                            </tr>
                            <tr key="name">
                                <th>Name</th>
                                <td>{depositBonus.name}</td>
                            </tr>
                            <tr key="currency">
                                <th>Currency</th>
                                <td>{depositBonus.currency_code}</td>
                            </tr>
                            <tr key="min_deposit">
                                <th>Min bonus</th>
                                <td>
                                    {depositBonus.min_deposit} {depositBonus.currency_code}
                                </td>
                            </tr>
                            <tr key="max_deposit">
                                <th>Max bonus</th>
                                <td>
                                    {depositBonus.max_deposit} {depositBonus.currency_code}
                                </td>
                            </tr>
                            <tr key="wagering_requirement">
                                <th>Wagering requirement</th>
                                <td>{depositBonus.wagering_requirement}x</td>
                            </tr>
                            <tr key="bonus_percentage">
                                <th>Bonus percentage</th>
                                <td>{depositBonus.bonus_percentage}%</td>
                            </tr>
                            <tr key="count_of_days_to_fill_requirements_by_user">
                                <th>Count of days to fill requirements by user</th>
                                <td>{depositBonus.count_of_days_to_fill_requirements_by_user}</td>
                            </tr>
                            <tr key="available_from">
                                <th>Available from</th>
                                <td>{moment.utc(depositBonus.available_from).format('YYYY-MM-DD HH:mm (z)')}</td>
                            </tr>
                            <tr key="available_to">
                                <th>Available to</th>
                                <td>{moment.utc(depositBonus.available_to).format('YYYY-MM-DD HH:mm (z)')}</td>
                            </tr>
                            <tr key="description">
                                <th>Description</th>
                                <td>{depositBonus.description && parse(depositBonus.description)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <BonusSummary bonusId={parseInt(id)} bonusType="casino deposit bonus" />
                <div className="card-footer">
                    <ActionButton
                        url={`${CASINO_DEPOSIT_BONUSES}/${depositBonus.id}/edit`}
                        title="Edit bonus"
                        permissions={[CRM_PERMISSION.DEPOSIT_BONUS_EDIT]}
                    />
                </div>
            </div>
        );
    };

    return <Loader loading={isLoading} content={getContent} />;
}

export default DepositBonusShow;
